import { Box, GlobalStyles } from '@mui/material';
import Footer from './AuthFooter';
import Header from './AuthHeader';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'utils/AuthContext';
import { ROUTE } from 'route/RouteEnums';
import COLORS from 'theme/colors';
import SelectPatientDialog from './SiblingSwitch/SelectPatientDialog';
import { usePatientSelectionPending } from './SiblingSwitch/patientSelection';

const AuthLayout = () => {
  const auth = useAuth();
  /** MM-1172: patient picker requested at sign-in or after the idle-timeout PIN. */
  const selectingPatient = usePatientSelectionPending();

  return (
    <>
      {auth.isAuthenticated ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
          }}
        >
          {/* only for dashboard layout bg color */}
          <GlobalStyles
            styles={{
              body: { backgroundColor: COLORS.LightYellow },
            }}
          />
          <Header />
          <Outlet />
          <Footer />
          {selectingPatient && !auth.user?.isAdmin ? <SelectPatientDialog /> : null}
        </Box>
      ) : (
        <Navigate to={{ pathname: ROUTE.LOGIN }} />
      )}
    </>
  );
};

export default AuthLayout;
